import { useEffect, useState } from "react";
import axios from "axios";
import { hasCookieConsent } from "@/components/CookieBanner";

const API = "/api";

export default function TrackingScripts() {
  const [config, setConfig] = useState(null);
  const [consented, setConsented] = useState(hasCookieConsent());

  useEffect(() => {
    axios.get(`${API}/admin/tracking`).then((r) => setConfig(r.data)).catch(() => {});
    const handler = () => setConsented(hasCookieConsent());
    window.addEventListener("cookie-consent-changed", handler);
    return () => window.removeEventListener("cookie-consent-changed", handler);
  }, []);

  useEffect(() => {
    if (!config || !consented) return;

    // Google Tag Manager
    if (config.gtm_active && config.gtm_id) {
      if (!document.getElementById("gtm-script")) {
        const script = document.createElement("script");
        script.id = "gtm-script";
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.gtm_id}');`;
        document.head.appendChild(script);

        // noscript fallback
        const noscript = document.createElement("noscript");
        noscript.id = "gtm-noscript";
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${config.gtm_id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.insertBefore(noscript, document.body.firstChild);
      }
    }

    // Facebook Pixel
    if (config.pixel_active && config.pixel_id) {
      if (!document.getElementById("fb-pixel-script")) {
        const script = document.createElement("script");
        script.id = "fb-pixel-script";
        script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${config.pixel_id}');fbq('track','PageView');`;
        document.head.appendChild(script);

        const noscript = document.createElement("noscript");
        noscript.id = "fb-pixel-noscript";
        noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${config.pixel_id}&ev=PageView&noscript=1"/>`;
        document.body.appendChild(noscript);
      }
    }
  }, [config, consented]);

  return null;
}

// Helper to fire conversion events from forms
export function trackLeadConversion(leadData = {}) {
  // Google Tag Manager dataLayer
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "lead_form_submit",
      lead_source: leadData.source || "wizard",
      lead_name: leadData.name || "",
      lead_email: leadData.email || "",
      landing_slug: leadData.landing_slug || "",
      product_name: leadData.product_name || "",
    });
  }
  // Facebook Pixel
  if (window.fbq) {
    window.fbq("track", "Lead", {
      content_name: leadData.product_name || leadData.source || "preventivo",
      content_category: leadData.landing_slug ? "landing_promo" : "wizard",
    });
  }
}
